import { ShareOption, SharingEvent } from '@news-mono/web-common'
import { useSectionMetaInfo } from '../../__helpers/use-section-meta'
import {
    StyledButton,
    StyledButtonText,
    StyledClipboardButton,
    StyledLinkedInIcon,
    StyledEmailIcon,
    StyledLinkIcon,
    StyledSharing,
    StyledCheckmarkIcon,
    StyledFacebookIcon,
} from './Sharing.styled'
import { getButtonOnClick } from '../../buttons/Sharing/utils/get-button-on-click'
import React, { useEffect } from 'react'

export interface TNSharingProps {
    /** When the loading flag is passed, the sharing icons will be
     * rendered but not be responsive, even if an invalid url is passed
     */
    loading?: boolean
    url: string
    text: string
    shareOptions: ShareOption[]
    layout?: 'stacked-md-desktop'
    onEvent: (event: SharingEvent) => void
    customCampaign?: string
    publicationId?: string
    postId?: string
}

export const Sharing: React.FC<TNSharingProps> = (props) => {
    const [copied, setCopied] = React.useState(false)
    const sectionMeta = useSectionMetaInfo()

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (copied) setCopied(false)
        }, 2000)

        return () => clearTimeout(timeout)
    }, [copied])

    if (!props.loading && !props.url) {
        return null
    }
    const getIcon = (shareOption: string) => {
        switch (shareOption) {
            case 'email_tn':
                return StyledEmailIcon
            case 'linkedin':
                return StyledLinkedInIcon
            case 'checkmark':
                return StyledCheckmarkIcon
            case 'facebook':
                return StyledFacebookIcon
            case 'clipboard':
                return StyledLinkIcon
            default:
                return
        }
    }
    const handleClick = (props: TNSharingProps, shareOption: ShareOption) => {
        if (props.loading) {
            return
        }
        props.onEvent({
            type: 'shareButton.click',
            originator: 'Sharing',
            payload: {
                shareType: shareOption,
                publicationId: props?.publicationId,
                postId: props?.postId,
            },
        })
        const onClick = getButtonOnClick(
            shareOption,
            props.url,
            props.text,
            sectionMeta.FacebookAppId,
            props.customCampaign,
        )
        onClick()
    }
    return (
        <StyledSharing>
            {props.shareOptions.map((shareOption, index) => {
                const gtmHook = `gtm-${shareOption}-share-button`
                const Icon = getIcon(shareOption)
                const TickIcon = getIcon('checkmark')
                if (!Icon || !TickIcon) {
                    return null
                }
                return shareOption === 'clipboard' ? (
                    <StyledClipboardButton
                        key={shareOption + index}
                        className={gtmHook}
                        onClick={() => {
                            setCopied(true), handleClick(props, shareOption)
                        }}
                    >
                        <StyledButtonText
                            className={copied ? 'copied' : 'default'}
                        >
                            <span>
                                <Icon />
                                Copy Link
                            </span>
                            <span>
                                <TickIcon />
                                Copied
                            </span>
                        </StyledButtonText>
                    </StyledClipboardButton>
                ) : (
                    <StyledButton
                        key={shareOption + index}
                        className={gtmHook}
                        onClick={() => handleClick(props, shareOption)}
                    >
                        <Icon />
                    </StyledButton>
                )
            })}
        </StyledSharing>
    )
}
